import { each, keys, sortBy } from 'lodash'

import { buildBreakpoints } from '../utils'

const breakpoints = {
  imac: 1920,
  desktop: 1680,
  laptop: 1440,
  tabletLarge: 1140,
  tablet: 1024,
  tabletPortrait: 820,
  mobile: 640,
  mobilePortrait: 480,
}

export default breakpoints

export const breakpointData = buildBreakpoints(breakpoints)
